import React, { useEffect, useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, makeStyles } from "@material-ui/core";
import { ColorBox } from "material-ui-color";
import { usePanelStyles, ModalTitle } from "../FormFields/panel";

const useStyles = makeStyles(() => ({
    // o ColorBox tem largura própria; no celular ele rola dentro do corpo em vez de estourar o modal
    body: {
        overflowX: "auto",
        "& > div": { margin: "0 auto" },
    },
}));

const ColorBoxModal = ({ onChange, currentColor, handleClose, open }) => {

    const classes = useStyles();
    const p = usePanelStyles();
    const [selectedColor, setSelectedColor] = useState(currentColor);

    useEffect(() => {
        setSelectedColor(currentColor);
    }, [currentColor]);

    const handleOk = () => {
        onChange(selectedColor);
        handleClose();
    };

    return (

        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="xs"
            aria-labelledby="color-box-title"
            classes={{ paper: p.dialogPaper }}
        >

            <ModalTitle id="color-box-title" title="Escolha uma cor" onClose={handleClose} />
            <DialogContent className={`${p.modalBody} ${classes.body}`}>
                <ColorBox
                    disableAlpha={true}
                    hslGradient={false}
                    value={selectedColor}
                    onChange={setSelectedColor} />
            </DialogContent>

            <DialogActions>

                <Button onClick={handleClose}>
                    Cancelar
                </Button>
                <Button
                    color="primary"
                    variant="contained"
                    onClick={handleOk} >
                    OK
                </Button>
            </DialogActions>
        </Dialog>
    )
}
export default ColorBoxModal;
